import autosize from 'autosize'
import base from 'components/base'
import componentInit from 'components/componentInit'
import main from 'main'
import utility from 'libraries/utility'
import $ from 'jquery'
import 'babel-polyfill'

class form extends base
{
  elements = {
    parent: null,
    form: null,
    fileInputs: [],
    textareas: [],
    submitButton: null,
    abortButton: null
  }

  params = {
    events: {
      onError: [],
      onSuccess: []
    }
  }

  abortController = null
  successfullySentChunks = []

  constructor(element, params)
  {
    super()

    if(typeof params === 'object')
      this.params = Object.assign(this.params, params)

    this.elements.form = $(element).get(0)
    this.elements.parent = $(this.elements.form).parent().get(0)
    this.elements.fileInputs = $(this.elements.form).find('input[type=file]').get()
    this.elements.textareas = $(this.elements.form).find('textarea').get()
    this.elements.submitButton = $(this.elements.form).find('input[type=submit]').get(0)

    this.bindEvents()
  }

  bindEvents()
  {
    $(this.elements.form).on('submit.'+ module.id, (event) =>
    {
      event.preventDefault()
      this.submit()
    })

    $(this.elements.fileInputs).on('change.'+ module.id, (event) =>
    {
      $(event.currentTarget).next('.message.input-error').remove()

      let inputName = $(event.currentTarget).attr('name').replace(/^attrs\[([^\]]+)\]$/, '$1')
      if(inputName && inputName.length > 0)
      {
        const fileMaxSize = $(this.elements.form).find('input[type=hidden][name="fileMaxSize['+ inputName +']"]').val()
        if(fileMaxSize && event.currentTarget.files[0].size > fileMaxSize)
        {
          $('<div class="message input-error">'+ main.framework.dict.application.filesizeExceedsLimit.replace(/\[filesize\]/, utility.formatBytesToHuman(event.currentTarget.files[0].size)).replace(/\[filesizeLimit\]/, utility.formatBytesToHuman(fileMaxSize)) +'</div>').insertAfter(event.currentTarget)
          $(event.currentTarget).val(null)
        }
      }
    })

    for(let textarea of this.elements.textareas)
      if($(textarea).is(':visible'))
        autosize(textarea)
  }

  async submit()
  {
    if(this.processing)
      return

    this.processing = true
    $(this.elements.form).toggleClass('processing', true)
    $(this.elements.form).find('.message').remove()

    const data = new FormData(this.elements.form)

    // Upload files.
    if(!await this.uploadFiles(data)) {
      this.processing = false
      $(this.elements.form).toggleClass('processing', false)
      this.toggleSubmitButtonText(this.elements.form)
      return
    }

    // Now submit rest of the form.
    const method = $(this.elements.form).attr('method')
    const url = $(this.elements.form).attr('action')
    this.processing = false
    this.runQuery({
      element: this.elements.form,
      type: method,
      url: url,
      input: data,

      // jQuery.ajax() should not process the data returned by FormData nor
      // should it worry about content type. Without these parameters, the query
      // fails.
      jQueryAjaxParams: {
        cache: false,
        contentType: false,
        processData: false
      },

      events: {
        onSuccess: [(query) =>
        {
          if(typeof this.params.events === 'object' && typeof this.params.events.onSuccess === 'object' && this.params.events.onSuccess.length > 0)
            this.runCallbacks('onSuccess', query)

          else
          {
            $(this.elements.parent).empty()

            let message = query.getMessage()
            if(message)
              $('<div class="message success">'+ message +'</div>').appendTo(this.elements.parent)
          }
        }],
        onError: [(query) =>
        {
          this.runCallbacks('onError', query)
        }]
      }
    })
  }

  async uploadFiles(formData)
  {
    const files = []
    for(const d of formData.entries()) {
      if(typeof d[1] === 'object' && d[1].constructor.name === 'File') {
        formData.delete(d[0])

        // On Webkit-based browsers d[1] is populated even if no file is
        // actually selected. Skip these entries.
        if(d[1].name === '' && d[1].size === 0)
          continue

        files.push(d)
      }
    }

    if(files.length === 0)
      return true

    // Upload files in 1 MB chunks.
    const chunks = []
    const chunkSize = 1 * 1000 * 1000
    for(const file of files) {
      const fileHash = await this.getFileHash(file[1])
      file.push(fileHash)

      const chunkAmount = Math.ceil(file[1].size / (chunkSize))
      for(let i = 0; i < chunkAmount; i++) {
        const chunk = file[1].slice(chunkSize * i, chunkSize * (i + 1))
        const chunkHash = await this.getFileHash(chunk)
        const chunkData = new FormData()
        chunkData.set('formSession', formData.get('formSession'))
        chunkData.set('fileHash', fileHash)
        chunkData.set(file[0], chunk)
        chunkData.set('chunkNumber', i + 1)
        chunkData.set('chunkHash', chunkHash)
        chunks.push({
          failCount: 0,
          data: chunkData
        })
      }
    }

    let body
    try
    {
      this.abortController = new AbortController()
      this.showUploadProgress(0, files.length)
      this.createAbortButton()

      const uploadPromises = []
      let successfullyUploadedChunks = 0
      for(let i = 0; i < chunks.length; i++) {
        const chunk = chunks[i]

        // Upload 5 chunks in parallel.
        if(i > 0 && i % 5 === 0)
          await Promise.all(uploadPromises)
          .catch((e) => {
            throw e
          })

        const promise = this.uploadChunk(chunk)
        .then(async (response) => {
          if(response.ok) {
            successfullyUploadedChunks++
            this.showUploadProgress(Math.round(successfullyUploadedChunks / chunks.length  * 100), files.length)
          }

          else {
            body = await response.json()
            throw new Error('chunk upload failed')
          }
        })

        uploadPromises.push(promise)
      }

      await Promise.all(uploadPromises)
      .catch((e) => {
        throw e
      })

      for(const key in files) {
        const file = files[key]
        formData.set('_fileChunks[' + key + '][key]', file[0])
        formData.set('_fileChunks[' + key + '][name]', file[1].name)
        formData.set('_fileChunks[' + key + '][size]', file[1].size)
        formData.set('_fileChunks[' + key + '][fileHash]', file[2])
      }

      return true
    }

    // Upload of a chunk failed. Output error and abort.
    catch(error)
    {
      this.processing = false
      $(this.elements.form).toggleClass('processing', false)
      $(this.elements.form).find('.message').remove()

      if(body && body.messages) {
        for(const message of body.messages) {
          if(message.type === 'error')
          {
            this.insertErrorMessage(message.message, {element: this.elements.form})
            continue
          }

          if(message.type !== 'inputError')
            continue

          let input = $(this.elements.form).find('[name="'+ message.data.field +'"]').get(0)
          if(!input)
          {
            const match = message.data.field.match(new RegExp('(.*)(\\[/\\^\\[0-9\]\\+\\$/\])$'))
            if(match && match[1])
              input = $(this.elements.form).find('[name="'+ match[1] +'[]"]').get(0)
          }

          if(!input)
            continue

          const messageElement = $('<div class="message input-error">'+ message.message +'</div>').get(0)
          const optionsElement = $(input).closest('.options').get(0)
          if(optionsElement)
            $(messageElement).insertAfter(optionsElement)
          else
            $(messageElement).insertAfter(input)
        }
      }

      return false
    }

    finally
    {
      this.hideUploadProgress()
      this.removeAbortButton()
    }
  }

  async uploadChunk(chunk)
  {
    const chunkId = [
      chunk.data.get('formSession'),
      chunk.data.get('fileHash'),
      chunk.data.get('chunkNumber'),
      chunk.data.get('chunkHash')
    ].join('-')

    if(this.successfullySentChunks.indexOf(chunkId) !== -1)
      return {ok: true}

    const chunksUrl = ($(this.elements.form).attr('action') + '?output=json&ajax=1&fileChunk=1').replace('?', '&').replace(/&+/, '?')
    const response = await window.fetch(chunksUrl, {
      method: 'POST',
      body: chunk.data,
      credentials: 'same-origin',
      signal: this.abortController.signal
    })

    if(response.ok)
      this.successfullySentChunks.push(chunkId)
    else
    {
      chunk.failCount++

      // Try uploading chunk 5 times.
      if(chunk.failCount < 5)
        return this.uploadChunk(chunk)
    }

    return response
  }

  abortUploads()
  {
    this.abortController.abort()
    throw this.abortController
  }

  createAbortButton()
  {
    this.elements.abortButton = $('<button class="abort">' + main.framework.dict.application.abort + '</button>').get(0)
    $(this.elements.abortButton).appendTo(this.elements.form)
    $(this.elements.abortButton).on('click.'+ module.id, (event) =>
    {
      event.preventDefault()
      this.abortUploads()
    })
  }

  removeAbortButton()
  {
    $(this.elements.abortButton).remove()
    this.elements.abortButton = null
  }

  async getFileHash(file)
  {
    const fr = new FileReader()
    fr.readAsArrayBuffer(file)
    const hashPromise = new Promise((resolve, reject) => {
      fr.onloadend = async () => {
        const hashBuffer = await window.crypto.subtle.digest('SHA-1', fr.result)
        const hashArray = Array.from(new Uint8Array(hashBuffer))
        const hash = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('')
        resolve(hash)
      }
    })

    return await hashPromise
  }

  showUploadProgress(percentage, fileCount)
  {
    let label
    if(fileCount > 1)
      label = main.framework.dict.application.uploadingFilesWithPercentage
    else
      label = main.framework.dict.application.uploadingFileWithPercentage

    label = label.replace('[percentage]', percentage)
    $(this.elements.submitButton).attr('value', label).toggleClass('long-label', true)
  }

  hideUploadProgress()
  {
    $(this.elements.submitButton).attr('value', main.framework.dict.application.formSubmit).toggleClass('long-label', false)
    this.toggleSubmitButtonText(this.elements.form)
  }
}

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  let elements = $(parentElement).find('form.custom-form').get()
  for(let element of elements)
    new form(element)
}

export default form



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/form.js